import { Play } from 'lucide-react';
import toast from 'react-hot-toast';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';
import useAutomationsStore from '../../../../../../store/useAutomationsStore';
import useAPI from '../../../../../../hooks/useAPI';
import useCompany from '../../../../../../hooks/useCompany';

export default function ManualTriggerNode({ id, data, selected }) {
  const { simulateFromNode, isSimulating, currentWorkflow, runWorkflow } = useAutomationsStore();
  const api = useAPI();
  const { activeCompany } = useCompany();

  const handleRun = async (e) => {
    e.stopPropagation();
    if (isSimulating) return;

    // Visual simulation
    simulateFromNode(id);

    // API call to run the workflow
    if (currentWorkflow && activeCompany?.id) {
      try {
        await runWorkflow(api, activeCompany.id, currentWorkflow.id, {});
        toast.success('Workflow execution started');
      } catch {
        toast.error('Failed to run workflow');
      }
    }
  };

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.triggers}
      icon={Play}
      label={data.label}
      hasInput={false}
      headerExtra={
        <button
          onClick={handleRun}
          disabled={isSimulating}
          className={[
            'w-6 h-6 rounded-md flex items-center justify-center transition',
            isSimulating
              ? 'bg-white/20 cursor-not-allowed'
              : 'bg-white/25 hover:bg-white/40 cursor-pointer',
          ].join(' ')}
          title="Run workflow"
        >
          <Play className="w-3 h-3 text-white fill-white" />
        </button>
      }
    >
      <p className="text-xs text-gray-500">{data.note || data.description}</p>
    </BaseNode>
  );
}
